import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
    Box,
    Button,
    TextField,
    Typography,
    Stack,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useAuthStore } from "../../store/auth.store";
import { forgotPassword } from "../../service/auth.service";

const RecoverSchema = Yup.object().shape({
    login: Yup.string().required("Login is required"),
});

interface RecoverFormValues {
    login: string;
}

export function PasswordRecoveryForm ({setLoading}:{setLoading: (b: boolean) => void}) {
    const { enqueueSnackbar } = useSnackbar();
    const authStore = useAuthStore();

    const initialValues: RecoverFormValues = { login: "" };

    const handleSubmit = (values: RecoverFormValues) => {
        setLoading(true);
        forgotPassword({login: values.login}).then(response => {
            enqueueSnackbar("If the provided email is registered in the system, a password recovery link has been sent to it.", {
                variant: "success",
            });
            authStore.setShowLogin(true)
            authStore.setShowResetPassword(false)
        }).catch((e) => {
            enqueueSnackbar({variant: 'error', message: "Failed to recover access - " + e.message})
        }).finally(() => {
            setLoading(false)
        })
    };

    return (
        <Box sx={{maxWidth: 450,  minWidth: 350, margin: "auto"  }}>
            <Box className={"mb-15"} >
                <Typography variant="h5" gutterBottom>
                    Recover Password
                </Typography>
            </Box>
            <Formik
                initialValues={initialValues}
                validationSchema={RecoverSchema}
                onSubmit={handleSubmit}
            >
                {({ handleChange, handleBlur, values, touched, errors }) => (
                    <Form>
                        <Box mb={2} className={"mb-15"} >
                            <TextField
                                fullWidth
                                name="login"
                                label="Login"
                                value={values.login}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.login && Boolean(errors.login)}
                                helperText={touched.login && errors.login}
                            />
                        </Box>
                        <Stack flexDirection={"row"}  justifyContent="space-between" alignItems="center">
                            <Button type="button" color="secondary" onClick={() => {
                                authStore.setShowResetPassword(false)
                            }}>
                                Close
                            </Button>
                            <Button type="button" color="secondary" onClick={() => {
                                authStore.setShowLogin(true)
                                authStore.setShowResetPassword(false)
                            }}>
                                Login
                            </Button>
                            <Button type="submit" variant="contained" color="primary">
                                Submit
                            </Button>
                        </Stack>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};
